var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backHome}},[_vm._v(_vm._s(_vm.$t('pages_error_page_back_btn_group_498')))]),_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backPrev}},[_vm._v(_vm._s(_vm.$t('pages_error_page_back_btn_group_499', [ _vm.second ])))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }